import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import successImage from './image.png';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

const ServiceSettingSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <img
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}`);
                    }}
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                    className={s.logo}
                />
            </div>
            <div className={s.content}>
                <img src={successImage} alt="success" />
                <h1>Service added!</h1>
                <p>You’ve successfully set up your services.</p>
                <p>Now let’s make your availability bookable — sync your calendar so patients can start scheduling appointments with you.</p>
                <Button
                    type="primary"
                    className={s.btn}
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR}`, { replace: true });
                    }}
                >Sync your availability calendar
                </Button>
                <Button
                    type="link"
                    className={s.linkBtn}
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}`, { replace: true });
                    }}
                >Back to homepage
                </Button>
            </div>
        </div>
    );
};

export default ServiceSettingSuccessPage;
